import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CmsModule } from '@signature-it/ngx-generic/components/cms';
import { UserLoginModuleGeneric } from '@signature-it/ngx-generic/components/user-login';
import { MainTopNavigationModuleGeneric } from '@signature-it/ngx-generic/components/top-navigation';
import { DropdownLangsModuleGeneric } from '@signature-it/ngx-generic/components/languages';
import { MainHeaderSearchFormModuleGeneric } from '@signature-it/ngx-generic/components/search-form';
import { PhoneOrderModule } from '@signature-it/ngx-generic/components/phone-order';
import { GroupsMenuModuleGeneric} from '@signature-it/ngx-generic/components/groups-menu';
import { CmsLinkModuleGeneric} from '@signature-it/ngx-generic/components/cms';
import { SearchModule_Catalogue } from '@signature-it/ngx-catalogue/components/search';
import { MainHeaderCartModuleGeneric } from '@signature-it/ngx-catalogue/components/cart-header';
import { MainHeaderNavbarMobileModule } from './navbar-mobile/navbar-mobile.module';
import { MainHeaderNavbarMobileTopModule } from './navbar-mobile/top/navbar-mobile-top.module';
import { MainHeaderComponent } from './main-header';
import { MainTaxNavModule } from "../../../main-tax-nav/main-tax-nav.module";
import { EntityBlockModuleGeneric } from "@signature-it/ngx-entity/components/entity-block";
import { BurgerMenuModule } from '@signature-it/ngx-generic/components/burger-menu';
import { CmsLinkEmbededModuleGeneric } from '@signature-it/ngx-generic/components/cms';
import {TaxonomyMenuModuleGeneric} from "@signature-it/ngx-entity/components/taxonomy-menu";
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        CmsModule,
        MainTopNavigationModuleGeneric,
        DropdownLangsModuleGeneric,
        UserLoginModuleGeneric,
        MainHeaderSearchFormModuleGeneric,
        MainHeaderCartModuleGeneric,
        MainHeaderNavbarMobileTopModule,
        SearchModule_Catalogue,
        MainHeaderNavbarMobileModule,
        PhoneOrderModule,
        GroupsMenuModuleGeneric,
        MainTaxNavModule,
        EntityBlockModuleGeneric,
        BurgerMenuModule,
        CmsLinkEmbededModuleGeneric,
	TaxonomyMenuModuleGeneric
    ],
    declarations: [MainHeaderComponent],
    exports: [MainHeaderComponent]
})
/**
 * @extends MainHeaderModuleGeneric
 */
export class MainHeaderModule {}
